import type { HelpFile } from '../../types/help'
import { AccessProfileDetailTestIds } from '../../../testids/AccessProfileDetailTestIds'

export const accessProfileDetailHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfileDetailTestIds.accessProfileDetailPage]:
      'Detail view of an access profile — its enforcement objects, owners, and the function groups that grant it.',
    [AccessProfileDetailTestIds.apFunctionGroupsCard]:
      'Function groups that are directly associated with this access profile. Identities assigned to these function groups inherit this access profile.',
    [AccessProfileDetailTestIds.btnActivate]:
      'Activate this access profile so it can be granted and provisioned to accounts.',
    [AccessProfileDetailTestIds.btnAddEnforcementObject]:
      'Add an enforcement object that this access profile grants on a target system.',
    [AccessProfileDetailTestIds.btnDeleteProfile]:
      'Permanently delete this access profile — existing grants will be invalidated.',
    [AccessProfileDetailTestIds.btnDeprecate]:
      'Mark as deprecated — blocks new requests while preserving existing grants.',
    [AccessProfileDetailTestIds.btnEdit]: null,
    [AccessProfileDetailTestIds.btnRetryFg]:
      'Retry loading function groups after a transient error.',
    [AccessProfileDetailTestIds.btnSelectAllEnforcementObjects]:
      'Select all enforcement objects for a bulk removal.',
    [AccessProfileDetailTestIds.cardProfileDetails]:
      'Core attributes of the access profile — name, code, description, status, and risk metadata.',
    [AccessProfileDetailTestIds.cardTitleEnforcementObjects]:
      'Enforcement objects (groups, permissions, roles on target systems) granted by this access profile.',
    [AccessProfileDetailTestIds.colActions]: null,
    [AccessProfileDetailTestIds.colEnforcementObject]: null,
    [AccessProfileDetailTestIds.colEoName]:
      'Name of the enforcement object as it appears on the target system.',
    [AccessProfileDetailTestIds.colEoSystem]:
      'Target system that hosts the enforcement object.',
    [AccessProfileDetailTestIds.colEoType]:
      'Type of enforcement object — group, permission, role, or other system-specific kind.',
    [AccessProfileDetailTestIds.colFgName]:
      'Name of the function group that grants this access profile.',
    [AccessProfileDetailTestIds.colFgType]:
      'Type of the function group — for example position-based or organization-based.',
    [AccessProfileDetailTestIds.colOperation]:
      'Operation applied when provisioning the enforcement object — typically grant, revoke, or sync.',
    [AccessProfileDetailTestIds.colSelect]: null,
    [AccessProfileDetailTestIds.colSystem]:
      'Target system on which the enforcement object lives.',
    [AccessProfileDetailTestIds.fgEmptyState]:
      'No function groups are associated with this access profile.',
    [AccessProfileDetailTestIds.linkResource]:
      'Open the resource detail for the underlying resource of this enforcement object.',
    [AccessProfileDetailTestIds.profileCode]:
      'Stable machine-readable code used to reference this access profile in rules and APIs.',
    [AccessProfileDetailTestIds.profileDescription]: null,
    [AccessProfileDetailTestIds.selectOperation]:
      'Provisioning operation applied when this enforcement object is activated — grant, revoke, or sync.',
  },
}
